module.exports = __webpack_public_path__ + "static/githzerai-136d3f99b8621d3bd42a7cb031eb680b.jpg";